//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.Teaching.js";
let d=[[],[[["name"],"GetFeatureGroupPriority",{R_:{priority:''}},1,0],[["name","priority"],"SetFeatureGroupPriority",{},2,0],[["name"],"GetFeatureGroupCondition",{R_:{condition:''}},1,0],[["name","condition"],"SetFeatureGroupCondition",{},2,0],[["name"],"GetOperationCondition",{R_:{condition:''}},1,0],[["name","condition"],"SetOperationCondition",{},2,0],[["name","operation_name"],"GetOperationAddonCondition",{R_:{condition:''}},2,0],[["name","operation_name","condition"],"SetOperationAddonCondition",{},3,0],[["n_feature_groups"],"GetFeatureGroups",{R_:{a_feature_groups:"CAM.FeatureGeometry[]"}},0,0],[["a_feature_groups"],"SetFeatureGroups",{},1,0],[[],"Teach",{},0,0]],[]];
SPLM.CAM.OperationSetTeaching = class extends SPLM.CAM.Teaching{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.OperationSetTeaching";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;